// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

// eslint-disable-next-line react/no-deprecated
import { render } from 'react-dom';
import { createPortal } from 'react';
import { gql } from '@apollo/client';
import { LocaleProvider, setDefaultPasswordEstimateFunction, setLocale } from '@plesk/ui-library';
import { Locale } from 'jsw';
import App from 'components/App';
import ErrorBoundary from 'components/common/ErrorBoundary';
import require from 'app';
import sentry from 'common/sentry';
import pageData from 'helpers/pageData';
import apolloClient from 'apolloClient';
import estimatePassword from 'helpers/estimatePassword';

export { require };
export { default as Form } from 'components/Form';

const isInFrame = () => {
    try {
        if (window.self === window.top) {
            return false;
        }
    } catch {
    }

    return true;
};

setDefaultPasswordEstimateFunction(password => estimatePassword(password));

let app = null;

export const run = ({
    config = {},
    data: { showModal, ...data } = {},
    graphqlQueries = [],
    localeSections = {},
    locale = undefined,
}) => {
    if (config.feedback) {
        sentry(config.feedback);
    }

    if (isInFrame()) {
        document.body.classList.add('page-content-only');
    }

    Locale.addSections(localeSections);

    pageData({ localeCode: locale, ...data });

    graphqlQueries.forEach(({ query, ...options }) => {
        try {
            apolloClient.writeQuery({
                query: gql(query),
                ...options,
            });
        } catch {}
    });

    if (locale) {
        setLocale(locale);
    }

    if (showModal) {
        const { name, ...props } = showModal;
        Plesk.require(name, run => run(props));
    }

    app = render(
        <App />,
        document.getElementById('plesk-root'),
    );
};

export const addWidget = (Component, { locale, ...props }, container) => {
    let widget = <Component {...props} />;

    if (locale) {
        widget = <LocaleProvider messages={locale}>{widget}</LocaleProvider>;
    }

    widget = (
        <ErrorBoundary>
            {widget}
        </ErrorBoundary>
    );

    if (container) {
        widget = createPortal(widget, container);
    }

    app.addWidget(widget);
};
